import { render, staticRenderFns } from "./SettingsPreferenceTable.vue?vue&type=template&id=1d10a7fc&scoped=true&"
import script from "./SettingsPreferenceTable.vue?vue&type=script&lang=js&"
export * from "./SettingsPreferenceTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPreferenceTable.vue?vue&type=style&index=0&id=1d10a7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d10a7fc",
  null
  
)

export default component.exports